const NAMESPACE = "anti_theft_device_invoice_analysis";

export function verdictLabel(t, verdict) {
  if (!verdict) return t(`${NAMESPACE}.verdict.unavailable`);
  const key = `${NAMESPACE}.verdict.${verdict}`;
  const label = t(key);
  return label === key ? verdict : label;
}

export function badgeClassFor(verdict) {
  switch (verdict) {
    case "PASS":
      return "bg-green-100 text-green-800";
    case "REVIEW":
      return "bg-yellow-100 text-yellow-800";
    case "FAIL":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-700";
  }
}

const DOCUMENT_TYPE_KEYS = ["invoice", "purchase_order", "electronic_receipt", "receipt", "other"];

export function documentTypeLabel(t, type) {
  if (!type) return "—";
  const key = DOCUMENT_TYPE_KEYS.includes(type) ? type : "other";
  return t(`${NAMESPACE}.document_type.${key}`);
}

export function isAnalysisAvailable(analysis) {
  if (!analysis || typeof analysis !== "object") return false;
  if (analysis.error) return false;
  return Boolean(analysis.overallVerdict);
}

const EXTRACTED_FIELD_KEYS = ["documentType", "buyerName", "purchaseDate", "lockDescription", "certificationMentions"];

export function mapExtractedFields(t, analysis) {
  const extracted = analysis?.extracted;
  if (!extracted) return [];
  return EXTRACTED_FIELD_KEYS.map((field) => ({
    label: t(`${NAMESPACE}.extracted_field.${field}`),
    value: field === "documentType" ? documentTypeLabel(t, extracted.documentType) : extracted[field] || "",
  }));
}

const CHECK_FIELDS = ["documentType", "buyerName", "lockEligibility", "purchaseDateCoherence"];

export function mapChecks(t, analysis) {
  const checks = analysis?.checks;
  if (!checks) return [];
  return CHECK_FIELDS.filter((field) => checks[field]).map((field) => ({
    field,
    label: t(`${NAMESPACE}.check.${field}`),
    verdict: checks[field]?.verdict,
    reason: checks[field]?.reason,
    extractedValue: checks[field]?.extractedValue || "",
    expectedValue: checks[field]?.expectedValue || "",
  }));
}

export function formatDateDelta(t, days) {
  if (days === null || days === undefined) return null;
  const value = Number(days);
  if (Number.isNaN(value)) return null;
  const absolute = Math.abs(value);
  if (absolute === 0) return t(`${NAMESPACE}.date_delta_value.same_day`);
  if (value > 0) return t(`${NAMESPACE}.date_delta_value.after`, absolute);
  return t(`${NAMESPACE}.date_delta_value.before`, absolute);
}

const DATE_DELTA_KEYS = ["vsBikePurchaseDays", "vsSubscriptionDays", "vsIncidentDays"];

export function mapDateDeltas(t, analysis) {
  const deltas = analysis?.dateDeltas;
  if (!deltas) return [];
  return DATE_DELTA_KEYS.filter((key) => deltas[key] !== null && deltas[key] !== undefined).map((key) => ({
    key,
    label: t(`${NAMESPACE}.date_delta.${key}`),
    value: formatDateDelta(t, deltas[key]),
  }));
}

export function formatAnalyzedAt(analyzedAt, locale = "fr-FR") {
  if (!analyzedAt) return "";
  const date = new Date(analyzedAt);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(locale);
}
